var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456,264.4V64a8,8,0,0,0-8-8H16a8,8,0,0,0-8,8V368a8,8,0,0,0,8,8H298.8A104,104,0,1,0,456,264.4ZM24,72H440V83.85L232,230.22,24,83.85Zm416,31.41V256a103.946,103.946,0,0,0-79.3-.28l-42.98-66.26ZM35.67,360H24V103.41l122.7,86.35Zm260.63,0H54.77L159.79,198.97l67.61,47.57a7.977,7.977,0,0,0,9.2,0l68.03-47.87,41.7,64.28A104.052,104.052,0,0,0,296,352Q296,356.035,296.3,360ZM400,440a88,88,0,1,1,88-88A88.1,88.1,0,0,1,400,440Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,280H384a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V288A8,8,0,0,0,416,280Zm-8,72H392V296h16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,376H384a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V384A8,8,0,0,0,416,376Zm-8,32H392V392h16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.079e6bc5790e4eb573c40175e5072fba.svg";
export { ForwardRef as ReactComponent };